import { StylesConfig } from 'react-select'
import { Theme } from 'styles/Themes'

export const selectStyles: StylesConfig<any> = {
  container: (base) => {
    return {
      ...base,
      width: '100%',
    }
  },
  valueContainer: (base) => {
    return {
      ...base,
      padding: 0,
      fontSize: 12,
      fontFamily: 'Inter',
      color: 'black',
      textAlign: 'left',
      margin: 0,
      width: 100,
    }
  },
  placeholder(base) {
    return {
      ...base,
      textAlign: 'left',
      fontFamily: 'Inter',
    }
  },

  control: (base, props) => {
    const isVacation =
      props.hasValue && props.getValue()[0]?.value === 'VACATION'
    const isInactive =
      props.hasValue && props.getValue()[0]?.value === 'INACTIVE'
    const isNew = props.hasValue && props.getValue()[0]?.value === 'NEW'
    const isActive = props.hasValue && props.getValue()[0]?.value === 'ACTIVE'

    const styles = {
      ...base,
      width: '100%',
      borderWidth: 1,
      borderRadius: 5,
      padding: '8px',
      fontSize: '12px',
      fontWheight: 400,
      outline: 'none',
      height: '40px',
      boxShadow: 'none',
      borderColor: '#424242',
      display: 'flex',
      alignItems: 'center',
      transition: 'all 0.3s ease-out',
      '&:hover': {
        borderColor: '#757575',
      },
      '&:isFocused ': {
        borderColor: '#1C1D22',
      },
    }

    if (isVacation || isInactive || isNew || isActive) {
      styles.border = 'transparent'
    }
    if (isVacation) {
      styles.backgroundColor = '#0087C129'
    }
    if (isActive) {
      styles.backgroundColor = '#28C76F29'
    }
    if (isInactive) {
      styles.backgroundColor = '#BDBDBD29'
    }
    if (isNew) {
      styles.backgroundColor = '#FFC60029'
    }

    return styles
  },
  option: (styles, props) => {
    return {
      ...styles,
      padding: '8px 12px',
      textOverflow: 'ellipsis',
      zIndex: 50,
      overflow: 'hidden',
      fontSize: 12,
      fontFamily: 'Inter',
      whiteSpace: 'nowrap',
      textAlign: 'left',
      fontWeight: '400',
      transition: 'all 0.3s ease-out',
      ':hover': {
        backgroundColor: 'rgb(245, 245, 245)',
      },
      backgroundColor: props.isSelected
        ? 'rgb(245, 245, 245)'
        : Theme.pallete.SECONDARY,
      color: props.isSelected ? '#1C1D22' : '#1C1D22',
    }
  },

  indicatorSeparator(base) {
    return {
      ...base,
      display: 'none',
    }
  },
  dropdownIndicator: (base, props) => {
    const isVacation =
      props.hasValue && props.getValue()[0]?.value === 'VACATION'
    const isInactive =
      props.hasValue && props.getValue()[0]?.value === 'INACTIVE'
    const isNew = props.hasValue && props.getValue()[0]?.value === 'NEW'
    const isActive = props.hasValue && props.getValue()[0]?.value === 'ACTIVE'

    let iconColor = 'black' // Default icon color
    if (isVacation) iconColor = '#0087C1'
    if (isInactive) iconColor = '#BDBDBD'
    if (isNew) iconColor = '#FFC600'
    if (isActive) iconColor = '#28C76F'

    return {
      ...base,
      padding: 0,
      color: iconColor,
      transition: 'all 0.3s ease-out',
    }
  },
  menu(base) {
    return {
      ...base,
      width: 180,
    }
  },
  menuList: (base) => ({
    ...base,
    zIndex: 40,
    width: 180,
    '::-webkit-scrollbar': {
      width: '8px',
      backgroundColor: '#C4C4C4',
      borderRadius: '50px',
    },
    '::-webkit-scrollbar-track': {
      background: '#fbfbfb',
      border: 0,
    },
    '::-webkit-scrollbar-thumb': {
      width: '8px',
      backgroundColor: '#C4C4C4',
      borderRadius: '50px',
    },
  }),
  singleValue: (base, props) => {
    const isVacation =
      props.hasValue && props.getValue()[0]?.value === 'VACATION'
    const isInactive =
      props.hasValue && props.getValue()[0]?.value === 'INACTIVE'
    const isNew = props.hasValue && props.getValue()[0]?.value === 'NEW'
    const isActive = props.hasValue && props.getValue()[0]?.value === 'ACTIVE'

    let textColor = 'black' // Default text color
    if (isVacation) textColor = '#0087C1'
    if (isInactive) textColor = '#BDBDBD'
    if (isNew) textColor = '#FFC600'
    if (isActive) textColor = '#28C76F'

    const styles = {
      ...base,
      color: textColor,
      fontFamily: 'Inter',
      fontSize: '12px',
      fontWeight: 400,
      marginLeft: '2px',
      transition: 'all 0.3s ease-out',
    }

    if (isVacation || isInactive || isNew || isActive) {
      styles.color = textColor
      styles.fontWeight = 600
    }
    return styles
  },
}

export const optionsLevels = [
  {
    label: 'Especialista',
    value: [0, 0, 1, 0, 0, 0, 0, 0, 0],
  },
  {
    label: 'Gestor Especialista',
    value: [0, 0, 1, 0, 1, 0, 0, 0, 0],
  },
  {
    label: 'Gestor',
    value: [0, 0, 0, 0, 1, 0, 0, 0, 0],
  },
  {
    label: 'Diretor',
    value: [0, 0, 0, 1, 0, 0, 0, 0, 0],
  },
  {
    label: 'Financeiro',
    value: [0, 0, 0, 0, 0, 1, 0, 0, 0],
  },
  {
    label: 'Analista de pagamentos',
    value: [1, 0, 0, 0, 0, 0, 0, 0, 0],
  },
  {
    label: 'Analista de contratos',
    value: [0, 1, 0, 0, 0, 0, 0, 0, 0],
  },
  {
    label: 'Jurídico',
    value: [0, 0, 0, 0, 0, 0, 1, 0, 0],
  },
  {
    label: 'Relação com investidor',
    value: [0, 0, 0, 0, 0, 0, 0, 1, 0],
  },
  {
    label: 'Gestor de usuários',
    value: [0, 0, 0, 0, 0, 0, 0, 0, 1],
  },
  {
    label: 'Owner',
    value: [1, 1, 1, 1, 1, 1, 1, 1, 1],
  },
]

export const optionsStatus = [
  {
    label: 'Novo',
    value: 'NEW',
  },
  {
    label: 'Ativo',
    value: 'ACTIVE',
  },
  {
    label: 'Inativo',
    value: 'INACTIVE',
  },
  {
    label: 'Férias',
    value: 'VACATION',
  },
]
export const optionsPermission = [
  {
    label: 'Visualizar',
    value: 'READ',
  },
  {
    label: 'Total',
    value: 'EDIT',
  },
]

export const optionsComission = [
  {
    label: 'Vendas',
    value: 'SALES',
  },
  {
    label: 'Gestão de carreira',
    value: 'MANEGMENT_CAREER',
  },
  {
    label: 'Meta de Equipe',
    value: 'META',
  },
]
